module.exports = __webpack_public_path__ + "img/videoVisitors.0af6aae2.png";